/**
 * @name    actionTracking
 * @autor   Holger Schauf
 * @type    controller
 * @desc    adapt html attributes to actiontracking push events
 * @date    07.2012
 * @example trackEvent = actionTrackingCategory,
 * @example acTrAc     = actionTrackingAction like "click"
 * @example acTrLa     = actionTrackingLabel like "layer"
 * @example acTrVa     = actionTrackingValue like 123
 */
window.actionTrackings = window.actionTrackings || [];

var actionTracking = (function ($) {
    return Class.extend({
        init: function (cfg) {
            this.alreadySent = false;

            this.cfg = Object.assign(
                {
                    trackingType: 'event tracking',
                    triggerName: arguments[1] || false,
                    trackEvent: 'current',
                    category: null,
                    acTrAc: 'click',
                    action: null,
                    acTrLa: '',
                    label: null,
                    acTrVa: 0,
                    value: 0,
                    sendOnce: true,
                    bindOn: 'click',
                    virtPath: null,
                    customDimensions: null,
                    nonInteraction: true,
                },
                cfg
            );

            this.cfg.category = this.cfg.category || this.cfg.trackEvent;
            this.cfg.action = this.cfg.action || this.cfg.acTrAc;
            this.cfg.label = this.cfg.label || this.cfg.acTrLa;
            this.cfg.value = this.cfg.value || this.cfg.acTrVa;

            if (this.cfg.category === 'current' && ApplicationProperties) {
                this.cfg.category =
                    ApplicationProperties.get('trackingGridName') ||
                    location.pathname;
            }

            this.setPushAction();
        },

        setPushAction: function () {
            if (this.cfg.triggerName !== false) {
                this.cfg.sendOnce
                    ? $(this.cfg.triggerName).one(
                          this.cfg.bindOn,
                          mote.doLater(this.push, this)
                      )
                    : $(this.cfg.triggerName).on(
                          this.cfg.bindOn,
                          mote.doLater(this.push, this)
                      );
            }
        },

        /**
         *
         * @returns {boolean}
         */
        push: function () {
            if (this.alreadySent && this.cfg.sendOnce) {
                return true;
            }

            var trackParams = [
                this.cfg.category,
                this.cfg.action,
                this.cfg.label,
                this.cfg.value,
                this.cfg.nonInteraction,
            ];

            stj.analytics.trackEvent(
                trackParams,
                this.cfg.virtPath,
                this.cfg.customDimensions
            );

            this.display();
            this.alreadySent = true;

            return true;
        },

        display: function () {
            if (!stj.debug || !stj.debug.cfg.writeAction) {
                return;
            }

            $('#TPLactionTrackingBox')
                .tmpl(this.cfg)
                .prependTo('#actionTrackingBox');
            $('#actionTrackingBox div:gt(10)').remove();
            $('#actionTrackingBox div:first-child').slideDown();
        },
    });
})(jQuery);

$(function ($) {
    $.fn.track = function (cfg) {
        return this.each(function () {
            new actionTracking(cfg, $(this));
        });
    };

    $('[track]').each(function () {
        var el = $(this);

        var options = el.attr('track').split(','),
            eventList = {
                input: 'change',
                form: 'submit',
                inputSubmit: 'click',
            };

        var cfg = mote.decipher(options);

        var tag = el[0].tagName.toLowerCase();

        if (tag === 'input' && el[0].type && el[0].type === 'submit') {
            tag = 'inputSubmit';
        }

        cfg.bindOn = eventList.hasOwnProperty(tag) ? eventList[tag] : 'click';

        new actionTracking(cfg, el);
    });
});

var processActionTrackings = function () {
    if (!window.actionTrackings.length) {
        return;
    }

    for (var index in window.actionTrackings) {
        var actionTrackingConf = window.actionTrackings[index];
        new actionTracking(actionTrackingConf).push();
        delete window.actionTrackings[index];
    }
};

setInterval(processActionTrackings, 500);
